import React from "react";
const Label = ({ children, className, ...props }) => {
  return (
    <label
      {...props}
      className={`block text-sm font-medium text-gray-700 mb-1 ${
        className || "static"
      }`}
    >
      {children}
    </label>
  );
};
export default Label;
